/* Moved from the inline <script> in snippets/price-range.liquid (PageSpeed batch 6). Guarded so it runs once even if the snippet renders twice. */
(function () {
  if (window.__kgPriceRangeButtonsLoaded) return;
  window.__kgPriceRangeButtonsLoaded = true;

  function initPriceFilterScript() {
    const buttons = document.querySelectorAll('.custom-price-range');
    if (!buttons.length) return;

    buttons.forEach(button => {
      button.removeEventListener('click', handlePriceFilterClick);
      button.addEventListener('click', handlePriceFilterClick);
    });
  }

  function handlePriceFilterClick(e) {
    e.preventDefault();
  
    const button = e.currentTarget;
    const min = button.dataset.min;
    const max = button.dataset.max;
  
    if (!min && !max) return;
  
    const form = document.getElementById('facets');
    const existingMinInput = form.querySelector('input[name="filter.v.price.gte"]');
    const existingMaxInput = form.querySelector('input[name="filter.v.price.lte"]');
  
    // Remove old hidden inputs if they exist
    if (existingMinInput) existingMinInput.remove();
    if (existingMaxInput) existingMaxInput.remove();
  
    // Add new hidden inputs
    if (min) {
      const minInput = document.createElement('input');
      minInput.type = 'hidden';
      minInput.name = 'filter.v.price.gte';
      minInput.value = min;
      form.appendChild(minInput);
    }
  
    if (max) {
      const maxInput = document.createElement('input');
      maxInput.type = 'hidden';
      maxInput.name = 'filter.v.price.lte';
      maxInput.value = max;
      form.appendChild(maxInput);
    }
  
    // Collect all current form values again
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
  
    const filterDrawer = document.querySelector('facet-filters');
    if (filterDrawer && filterDrawer.applyFilters) {
      filterDrawer.applyFilters(params.toString(), e);
    } else {
      window.location.href = `${window.location.pathname}?${params.toString()}`;
    }
  }
  
  function syncFiltersOnPageLoad() {
    const url = new URL(window.location.href);
    const minPrice = url.searchParams.get('filter.v.price.gte');
    const maxPrice = url.searchParams.get('filter.v.price.lte');
  
    const buttons = document.querySelectorAll('.custom-price-range');
    const radios = document.querySelectorAll('.radio-mark');
  
    buttons.forEach((button, index) => {
      const min = button.dataset.min;
      const max = button.dataset.max;
      button.classList.remove('active');
      radios[index].classList.remove('active');
  
      if (String(minPrice) === String(min) && (!max || String(maxPrice) === String(max))) {
        button.classList.add('active');
        radios[index].classList.add('active');
      }
    });
  
    // ✅ Reinject price filters into form if they exist in URL
    const form = document.getElementById('facets');
    if (form) {
      const existingMin = form.querySelector('input[name="filter.v.price.gte"]');
      const existingMax = form.querySelector('input[name="filter.v.price.lte"]');
  
      if (existingMin) existingMin.remove();
      if (existingMax) existingMax.remove();
  
      if (minPrice) {
        const minInput = document.createElement('input');
        minInput.type = 'hidden';
        minInput.name = 'filter.v.price.gte';
        minInput.value = minPrice;
        form.appendChild(minInput);
      }
  
      if (maxPrice) {
        const maxInput = document.createElement('input');
        maxInput.type = 'hidden';
        maxInput.name = 'filter.v.price.lte';
        maxInput.value = maxPrice;
        form.appendChild(maxInput);
      }
    }
  }
  

  function observePriceRangeChanges() {
    const target = document.querySelector('price-range');
    if (!target) return;

    const observer = new MutationObserver(() => {
      syncFiltersOnPageLoad();
      initPriceFilterScript();
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncFiltersOnPageLoad();
    initPriceFilterScript();
    observePriceRangeChanges();
  });

  document.addEventListener('on:facet-filters:updated', () => {
    syncFiltersOnPageLoad();
    initPriceFilterScript();
  });
  window.initPriceFilterScript = initPriceFilterScript;
  window.handlePriceFilterClick = handlePriceFilterClick;
  window.syncFiltersOnPageLoad = syncFiltersOnPageLoad;
  window.observePriceRangeChanges = observePriceRangeChanges;
})();
